import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Errors, actions } from 'react-redux-form';
import { Link } from 'react-router-dom';
import get from 'lodash/get';
import { credentialsPath } from '../Forms/Schemas/baseRrf';
import Credentials from '../Forms/Credentials';

import {
  signUpWithEmailPassphrase,
} from '../../actions';
import {
  addNotification,
} from '../../actions/notifications';
import Button from '../Button';

import './SetUpCredentials.css';


// const debug = require('debug')('cambria:SignUp:SetUpCredentials');


export class UnconnectedSetUpCredentials extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
    };
    this.onAuthToken(this.props.authToken);
  }

  componentWillReceiveProps(nextProps) {
    this.onAuthToken(nextProps.authToken);
  }

  onAuthToken = (token) => {
    if (token) {
      this.props.onNext();
      return true;
    }
    return false;
  }

  onSubmit = async () => {
    if (this.state.submitting) {
      return;
    }
    const { email, passphrase } = this.props;
    this.setState({ submitting: true });
    try {
      await this.props.signUpWithEmailPassphrase(email, passphrase);
      return;
    } catch (err) {
      if (err.res) {
        if (err.res.status === 400) {
          const resBody = await err.res.json();
          const fieldErrors = Object.keys(resBody.error.validationErrors).reduce((acc, name) => {
            acc[name] = resBody.error.validationErrors[name].msg;
            return acc;
          }, {});
          this.props.setFieldsErrors(credentialsPath, fieldErrors);
        } else if (err.res.status === 409) {
          this.props.setFieldsErrors(credentialsPath, {
            email: {
              inUse: true,
            },
          });
        } else {
          this.props.addNotification(`Account creation failed ${err.message}. Please try again later.`);
        }
      } else {
        this.props.addNotification(`Account creation failed ${err.message}. Please try again later.`);
      }
    }
    this.setState({ submitting: false });
  }

  render() {
    return (
      <div className="SignUpSetUpCredentials">
        <Form
          model={credentialsPath}
          onSubmit={this.onSubmit}
          className={this.state.submitting ? 'submitting' : ''}
          validators={{
            '': {
              passwordsMatch: vals => (
                (!vals.verifyPassphrase ||
                vals.verifyPassphrase === '') ||
                vals.passphrase === vals.verifyPassphrase),
            },
          }}
          onChange={() => this.props.resetValidity(`${credentialsPath}.email`, ['inUse'])}
        >
          <div styleName="spaceBetweenFormGroups">
            <Credentials credentialsPath={credentialsPath} />
            <Errors
              styleName="errorText"
              show={form => form.touched || form.submitted}
              model={credentialsPath}
              messages={{
                  passwordsMatch: 'Passwords must match.',
                }}
            />
          </div>
          <div styleName="submitButtonContainer">
            <Button
              disabled={this.state.submitting}
              type="submit"
            >
              {this.state.submitting ? 'Submitting' : 'Create Account'}
            </Button>
          </div>
        </Form>

        <div styleName="already-have-account">
          Already have an account? <Link styleName="link" to="/login" >Log in here.</Link>
        </div>
      </div>
    );
  }
}


const mapStateToProps = ({ authToken, rrSignupForms }) => ({
  authToken,
  email: get(rrSignupForms, 'credentials.email', ''),
  passphrase: get(rrSignupForms, 'credentials.passphrase', ''),
});

const mapDispatchToProps = {
  signUpWithEmailPassphrase,
  setFieldsErrors: actions.setFieldsErrors,
  resetValidity: actions.resetValidity,
  addNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(UnconnectedSetUpCredentials);



// WEBPACK FOOTER //
// ./src/components/SignUp/SetUpCredentialsRrf.js